import { render, staticRenderFns } from "./SelfBillInfo.vue?vue&type=template&id=3990e6c2&scoped=true&"
import script from "./SelfBillInfo.vue?vue&type=script&lang=js&"
export * from "./SelfBillInfo.vue?vue&type=script&lang=js&"
import style0 from "./SelfBillInfo.vue?vue&type=style&index=0&id=3990e6c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990e6c2",
  null
  
)

export default component.exports